import { render, staticRenderFns } from "./updateVip.vue?vue&type=template&id=954cc114&scoped=true&lang=pug"
import script from "./updateVip.vue?vue&type=script&lang=js"
export * from "./updateVip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954cc114",
  null
  
)

export default component.exports